// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"298":"80664a20","395":"3d85426c","787":"f096db70"}[chunkId] + ".chunk.js";
};